<template>
  <div class="menuBody"  style="padding-left:25px;">
        <BillManagementDialog :param="diaLogData" ref="BillManagementDialog" @Visible="Visible" />
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据管理组设置  
            </div>
             <div style="width:180px;float:left;margin-right:30px">
                 <el-input placeholder="请输入票据管理组代号" size="small"     v-model="groupNum"></el-input>
            </div>
             <div style="width:180px;float:left;margin-right:30px">
                 <el-input placeholder="请输入票据管理组名称" size="small"     v-model="groupName"></el-input>
            </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmGs:selectListPage'"  @click="Inquire()">查询</el-button>
            </div>
            <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmGs:save'" @click="PropertyAdd()">票据管理组添加</el-button>
            </div>
              <el-table  :data="tableData"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  v-loading="loading" tooltip-effect="light"    style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="groupNum" label="票据管理组代号"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="groupName" label="票据管理组名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注" ></el-table-column>
    <el-table-column fixed="right" label="操作" width="150">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"  v-Jurisdiction="'expense:web:bs:bmGs:save'"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce  v-Jurisdiction="'expense:web:bs:bmGs:delete'"></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillManagementDialog from "../common/BillManagementDialog";
export default {
  name: "BillManagement",
  components: {BillManagementDialog},
  data() {
    return {
        loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        groupNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      taxRateval:"",
      taxRatelab:"",
    }
  },
  methods: {
    AmountChange(){
      var arr = this.amountval
      var ende = arr[arr.length-1]
      for(let val of this.amount){
        if(this.amountval == val.value){
          this.taxRateval = val.value
          this.taxRatelab = val.label
        }else{
          var end = arr[0]
          if(end == val.value){
            for(let arr of val.children){
              if(ende == arr.value){
                  this.taxRateval = arr.value
                  this.taxRatelab = arr.label
              }
            }
          }
        }
      }
    },
    expend(){
    },
    handleSelectionChange(val){
      this.USERObj= val
    },
    getMsgFormSon(data){
      this.AllData = data
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "groupNum":this.groupNum,
        "groupName":this.groupName,
      }
        this.$http.post(this.$requestUrl.POST_BILL_MANLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
        this.$http.post(this.$requestUrl.POST_BILL_MANLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    PropertyAdd(){
        // 添加项目
        if(this.USERObj.length == 0){
            this.$refs.BillManagementDialog.title = "添加";
      this.$refs.BillManagementDialog.dialogVisible = true; 
          let obj = {
            "groupNum":"票据类型代号",
            "groupName":"票据类型名称",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
         this.$refs.BillManagementDialog.formLabelAlign= row;
        }
    },
    editMenu(row) { // 修改
      this.$refs.BillManagementDialog.title = "修改";
      this.$refs.BillManagementDialog.dialogVisible = true;
        let obj = {
            "groupNum":"票据类型代号",
            "groupName":"票据类型名称",
            "remarks":"备注信息",
          }
        row.obj = obj
         this.$refs.BillManagementDialog.formLabelAlign= row;
        },
    delMenu(row){
       this.$confirm('是否确认要删除该科目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      this.$http.post(this.$requestUrl.DELETE_BILL_MAN+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.getAllMenu()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
     RevenueType(){
          this.$http.get(this.$requestUrl.GET_CHARGE_LIST).then((res)=>{
           let result = res.data;
        if (200 === result.code) {
          this.RevenueTypeone(result.data)
        }
        })
    },
    RevenueTypeone(params){
       var result = [];
                for (let val of params) {
                  if(val.parentCode == null || val.parentCode == ""){
                    var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    parent.children = this.RevenueTypeTwo(val.subjectsCode,params)
                    result.push(parent);
                  }
                  if(val.parentCode == "0"){
                     var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "1"){

                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "600110"){  
                          var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  if(val.parentCode == "29290"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  if(val.parentCode == "10802"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  this.amount = result
    }
  },
      RevenueTypeTwo(id,array){
        let childs = new Array();
        for(let arr of array){
          if (arr.parentCode == id) {
           childs.push({
               'label': arr.subjectsName,
               'value': arr.subjectsCode,
               'type':arr.parentCode,
           });
          }
        }
         return childs;
    },
    ItemWeight(){
          this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
           let result = res.data;
           let arr = []
           for(let val of result.data){
               if(val.feeCategory == "01"){
                let obj = {
                   "value":val.feeCode,
                   "label":val.feeName,
                   "type":val.id,
                   "subjectsCode":val.subjectsCode,
                   "subjectsName":val.subjectsName,
               }
               arr.push(obj)
               }
           }
           this.options = arr
        })
    },
    Visible(data){
      if(data == false){
        this.loading = true
        this.getAllMenu();
      }
    }

  },
  mounted() {
      this.ItemWeight();
      this.getAllMenu();
  }
}
</script>

<style lang="scss">
.menuBody {
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>